module.exports = __webpack_public_path__ + "img/54d7b9a.jpg";